DialogController = App.loadClass 'core::Angular/DialogController'
Product = App.loadClass 'portal::Angular/Ratings/Models/Product'

class exports.EditProductDialogController extends DialogController

    constructor: (@scope, @transitions, @repo, @modalInstance, $timeout, @q, lineups_id, product) ->
        super(@scope, @transitions, @modalInstance)
        self = this

        # empty model for editing within the scope of this dialog
        p = new Product()
        $.extend p, product # copy existing model
        # set seed company and trait package names so the cell values are set correctly
        p.seed_company_name = _.find(@scope.$parent.seed_companies, id: p.seed_companies_id).name
        p.trait_package_name = _.find(@scope.$parent.trait_packages, id: p.trait_packages_id).name
        @existing_companies = @scope.$parent.seed_companies
        @existing_traits = @scope.$parent.trait_packages
        @existing_products = @scope.$parent.existing_products
        @original_product = product

        @scope.product = [p]
        @scope.title = 'Edit Product'

        @scope.absolute_errors = false
        @scope.show_overflow = true # so that dropdowns don't create scrollbars

        @lineups_id = lineups_id

        # handsontable configuration
        @scope.hot_settings =
            currentColClassName: 'highlighted'
            currentRowClassName: 'highlighted'
            invalidCellClassName: 'invalid'
            allowInsertColumn: false
            allowRemoveColumn: false
            maxRows: 1 # prevent adding or removing rows
            allowInsertRow: false
            allowRemoveRow: false
            rowHeaders: false

            # hooks
            afterInit: ->
                # `this` is the HoT instance (the `Core` object)
                # this is why, this is why, this is why I'm hot
                self.hot = this

            afterRender: @afterRender
            beforeKeyDown: @beforeKeyDown
            beforeValidate: @beforeValidate

        @scope.$watchCollection '$parent.seed_companies'
            , @seedCompaniesChanged
            # doesn't need a deep watch

        @scope.$watch '$parent.trait_packages'
            , @traitPackagesChanged
            , true # deep watch to pick up (de)activated trait packages

        # create lists of just the names to use for validation
        @seed_company_names = (sc.name for sc in @scope.$parent.seed_companies)
        @trait_package_names = (tp.name for tp in @scope.$parent.trait_packages when tp.active)

        # stupid flag that's only used to check whether or not we can save the
        # data, because Handsontable doesn't provide any way of detecting that.
        @valid = true

        @scope.validateSeedCompany = @validateSeedCompany
        @scope.validateName = @validateName
        @scope.validateTraitPackage = @validateTraitPackage

        # AGH! GROSS HAX ALERT!! HERE BE JQUERY!
        # This is necessary in order to have the add product button appear in
        # the table header and also use the ng-click binding. Handsontable
        # technically allows HTML in column headers, but I couldn't find a way
        # to have Angular evaluate the HTML when/after creating the table.
        # So the solution is to create the buttons in the dialog (outside the
        # Handsontable), and copy them into the table each time it renders.
        $timeout =>
            # only do this once the dialog is loaded
            # @sc_button = $('.btn-add-seed-company').detach()
            @tp_button = $('.btn-add-trait-package').detach()
            @attachButtons()

    attachButtons: =>
        # THIS IS ALSO BAD HAX BECAUSE IT USES JQUERY.
        # One thing to note about these selectors:
        # Handsontable actually duplicates the table containing the thead
        # (for scrolling, I think), and `thead th:nth-child(1)` matches the
        # first `th` in *both* `thead`s. Fancy!
        # $('.edit-product-hot thead th:nth-child(1)>div').append(@sc_button)
        $('.edit-product-hot thead th:nth-child(3)>div').append(@tp_button)


    # Handsontable Hooks

    afterRender: =>
        @attachButtons()

    beforeKeyDown: (e) =>
        # prevent escape from closing the dialog
        if e.which is 27
            e.stopPropagation()

    beforeValidate: (value, row, prop, source) =>
        # Need additional cell info to validate properly. Validator
        # functions will receive this object, not just a string value.
        cell =
            value: value
            row: row
            prop: prop
            elem: @hot.getCell(row, @hot.propToCol(prop))

        return cell


    # Validation

    seedCompaniesChanged: (seed_companies) =>
        # make sure we update the dropdowns when we create a new seed company
        @scope.product[0].seed_companies = seed_companies

        # update list of names for validation
        @seed_company_names = (sc.name for sc in seed_companies)

    traitPackagesChanged: (trait_packages) =>
        # make sure we update the dropdowns when we create a new trait package
        @scope.product[0].trait_packages = trait_packages

        # update list of names for validation
        @trait_package_names = (tp.name for tp in trait_packages when tp.active)


    validateSeedCompany: (cell, callback) =>
        # check whether they entered a valid seed company
        if cell.value not in @seed_company_names
            return @markInvalid(cell, '''
                Seed Company is required (Hint: Input must exactly match one of
                the Seed Companies you\'ve already added. If you don\'t see the
                Seed Company in the dropdown list, please contact MyFarms
                Support.)
            ''', callback)

        # check uniqueness
        if not @_isUniqueProduct(cell)
            product = @hot.getSourceDataAtRow(cell.row)
            return @markInvalid(cell, """
                You already have a Product with the Seed Company
                \"#{cell.value}\", the Name \"#{product.name}\", and the Trait
                Package \"#{product.trait_package_name}\"
            """, callback)

        return @markValid(cell, callback)

    validateName: (cell, callback) =>
        # check if the name is set
        if cell.value is ''
            return @markInvalid(cell, 'Name is required', callback)

        # check the length
        if cell.value.length > 50
            return @markInvalid(cell, 'Name cannot be longer than 50 characters', callback)

        # check uniqueness
        if not @_isUniqueProduct(cell)
            product = @hot.getSourceDataAtRow(cell.row)
            return @markInvalid(cell, """
                You already have a Product with the Seed Company
                \"#{product.seed_company_name}\", the Name \"#{cell.value}\",
                and the Trait Package \"#{product.trait_package_name}\"
            """, callback)

        return @markValid(cell, callback)

    validateTraitPackage: (cell, callback) =>
        # check whether they entered a valid trait package
        if cell.value not in @trait_package_names
            return @markInvalid(cell, '''
                Trait Package is required (Hint: Input must exactly match one of
                the Trait Packages you\'ve already added. If you don\'t see the
                Trait Package in the dropdown list, you can add it now by
                clicking the "+" button above.)
            ''', callback)

        # check uniqueness
        if not @_isUniqueProduct(cell)
            product = @hot.getSourceDataAtRow(cell.row)
            return @markInvalid(cell, """
                You already have a Product with the Seed Company
                \"#{product.seed_company_name}\", the Name \"#{product.name}\",
                and the Trait Package \"#{cell.value}\"
            """, callback)

        return @markValid(cell, callback)

    ###
    use given cell to validate unique product names
    ###
    _isUniqueProduct: (cell) =>
        # Get row and clone data to make it easier to work with
        edited = $.extend({}, @hot.getSourceDataAtRow(cell.row))
        edited[cell.prop] = cell.value

        # Return if not all columns are filled
        if not edited.name or not edited.seed_company_name or not edited.trait_package_name
            return true

        # get trait id and seed company id
        tp = _.find(@existing_traits, 'name': edited.trait_package_name)
        sc = _.find(@existing_companies, 'name': edited.seed_company_name)

        # if trait and company do not exist
        if not tp or not sc
            return true

        edited.trait_packages_id = tp.id
        edited.seed_companies_id = sc.id

        # find duplicates
        duplicates = _.filter @existing_products, (p) =>
            same_name = p.name.trim() is edited.name.trim()
            same_sc = p.seed_companies_id is edited.seed_companies_id
            same_trait = p.trait_packages_id is edited.trait_packages_id

            # return if its a duplicate
            return same_name and same_sc and same_trait

        is_same = edited.seed_companies_id is @original_product.seed_companies_id and
                  edited.trait_packages_id is @original_product.trait_packages_id and
                  edited.name is @original_product.name

        return duplicates.length is 0 or is_same

    # TODO: move these functions into handsontable/fancy-validation.coffee too
    markInvalid: (cell, msg, callback = null) =>
        # the `_#{cell.prop}_validation` attribute is used by the
        # validated___ cell renderers in handsontable/fancy-validation.coffee
        @hot.getSourceDataAtRow(cell.row)?["_#{cell.prop}_validation"] =
            status: 'invalid'
            message: msg

        @valid = false
        callback?(false)

        return false

    markValid: (cell, callback = null) =>
        @hot.getSourceDataAtRow(cell.row)?["_#{cell.prop}_validation"] =
            status: 'success'
            message: null

        callback?(true)

        return true

    # Saving

    save: =>
        # This is stupid, but I haven't found any better way to check for
        # invalid cells
        @valid = true

        deferred = @q.defer() # needed by the mfClickAndDisable directive
        @hot.validateCells =>
            if @valid
                result = @actuallySaveData()
                deferred.resolve result
            else
                deferred.reject()

        @clearAllTooltips()
        return deferred.promise

    actuallySaveData: =>
        @setAlert(type: 'info', msg: 'Saving product')
        seed_companies = @scope.$parent.seed_companies
        trait_packages = @scope.$parent.trait_packages

        product = @scope.product[0]

        # look up FKs, because HoT only sets the name (using the dropdown)
        # it may be better to do this in an afterChange handler on the cell
        # but this is simpler
        product.seed_companies_id = _.find(seed_companies, name: product.seed_company_name).id
        product.trait_packages_id = _.find(trait_packages, name: product.trait_package_name).id

        promise = @repo.updateProduct(@lineups_id, product).then (response) =>
            if response.status?.type
                @closeWithAlert response.status, response.data

        .catch (response) =>
            @closeWithAlert(type: 'error', msg: 'Failed to save product')

        return promise

    clearAllTooltips: () =>
        $('.qtip').each () ->
            $(this).data('qtip').destroy()

    cancel: () =>
        @clearAllTooltips()
        super()
